/* Roverland YMM fitment: vehicle finder, saved vehicle ("My Garage"), product fit badge. */
(function () {
  var dataEl = document.getElementById('ymm-data');
  if (!dataEl) return;
  var DATA = JSON.parse(dataEl.textContent); // { make: { model: [years] } }
  var KEY = 'rl_ymm_vehicle';

  var byYear = {};
  Object.keys(DATA).forEach(function (make) {
    Object.keys(DATA[make]).forEach(function (model) {
      DATA[make][model].forEach(function (y) {
        byYear[y] = byYear[y] || {};
        (byYear[y][make] = byYear[y][make] || []).push(model);
      });
    });
  });
  var YEARS = Object.keys(byYear).map(Number).sort(function (a, b) { return b - a; });

  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function handleOf(v) { return v.year + '-' + slug(v.make) + '-' + slug(v.model); }
  function nameOf(v) { return v.year + ' ' + v.make + ' ' + v.model; }
  function urlOf(v) { return '/collections/' + handleOf(v); }

  function getVehicle() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function setVehicle(v) {
    try { v ? localStorage.setItem(KEY, JSON.stringify(v)) : localStorage.removeItem(KEY); } catch (e) {}
    document.dispatchEvent(new CustomEvent('ymm:change', { detail: v }));
  }

  function fill(select, values, placeholder) {
    select.innerHTML = '';
    var o = document.createElement('option');
    o.value = ''; o.textContent = placeholder; select.appendChild(o);
    values.forEach(function (v) { var op = document.createElement('option'); op.value = v; op.textContent = v; select.appendChild(op); });
    select.disabled = !values.length;
  }

  /* ---------- Finder (header bar + product "check fit") ---------- */
  function initFinder(root) {
    var mode = root.getAttribute('data-mode') || 'navigate';
    var year = root.querySelector('[data-ymm-year]');
    var make = root.querySelector('[data-ymm-make]');
    var model = root.querySelector('[data-ymm-model]');
    var go = root.querySelector('[data-ymm-go]');

    var q = root.querySelector('[data-ymm-q]');
    function refreshButton() { if (go) go.disabled = !(year.value && make.value && model.value); }
    function onYear() {
      var makes = year.value ? Object.keys(byYear[year.value]).sort() : [];
      fill(make, makes, 'Make');
      if (makes.length === 1) make.value = makes[0];
      onMake();
    }
    function onMake() {
      var models = year.value && make.value ? byYear[year.value][make.value].slice().sort() : [];
      fill(model, models, 'Model');
      refreshButton();
    }
    function submit() {
      if (!(year.value && make.value && model.value)) return;
      var v = { year: +year.value, make: make.value, model: model.value };
      setVehicle(v);
      if (mode === 'navigate') window.location.href = urlOf(v) + (q && q.value.trim() ? '?q=' + encodeURIComponent(q.value.trim()) : '');
    }
    if (q) q.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });

    fill(year, YEARS, 'Year');
    fill(make, [], 'Make');
    fill(model, [], 'Model');
    year.addEventListener('change', onYear);
    make.addEventListener('change', onMake);
    model.addEventListener('change', function () { refreshButton(); if (mode === 'check') submit(); });
    if (go) go.addEventListener('click', submit);
    // When the vehicle is cleared, reset this finder to empty dropdowns.
    document.addEventListener('ymm:change', function (e) {
      if (e.detail) return;
      year.value = ''; onYear();
      if (q) q.value = '';
    });

    var current = getVehicle();
    if (current && byYear[current.year] && mode === 'navigate') {
      year.value = current.year; onYear();
      make.value = current.make; onMake();
      model.value = current.model; refreshButton();
    }
  }

  /* ---------- Saved vehicle chip in the finder bar ---------- */
  function renderGarage() {
    var v = getVehicle();
    document.querySelectorAll('[data-ymm-garage]').forEach(function (el) {
      var bar = el.closest('[data-ymm-bar]');
      if (v) {
        el.querySelector('[data-ymm-garage-name]').textContent = nameOf(v);
        el.querySelector('[data-ymm-garage-link]').href = urlOf(v);
        el.hidden = false;
        if (bar) bar.classList.add('has-vehicle');
      } else {
        el.hidden = true;
        if (bar) bar.classList.remove('has-vehicle');
      }
    });
  }

  /* ---------- Product page fitment ---------- */
  function rangesFor(list) {
    var groups = {};
    list.forEach(function (v) { var k = v.make + '|' + v.model; (groups[k] = groups[k] || []).push(v.year); });
    return Object.keys(groups).sort().map(function (k) {
      var ys = groups[k].sort(function (a, b) { return a - b; }), out = [], start = ys[0], prev = ys[0];
      for (var i = 1; i <= ys.length; i++) {
        if (ys[i] !== prev + 1) { out.push(start === prev ? String(start) : start + '–' + prev); start = ys[i]; }
        prev = ys[i];
      }
      var parts = k.split('|');
      return { label: out.join(', '), make: parts[0], model: parts[1] };
    });
  }

  function initFit(root) {
    var list = JSON.parse(root.querySelector('[data-ymm-fit-data]').textContent);
    var handles = list.map(handleOf);
    var listEl = root.querySelector('[data-ymm-fit-list]');
    if (listEl) {
      listEl.innerHTML = rangesFor(list).map(function (r) {
        return '<li><span class="ymm-fit__years">' + r.label + '</span> ' + r.make + ' ' + r.model + '</li>';
      }).join('');
    }
    var status = root.querySelector('[data-ymm-fit-status]');
    var checker = root.querySelector('[data-ymm-fit-check]');

    function render() {
      var v = getVehicle();
      if (!v) {
        status.hidden = true; checker.hidden = false;
        return;
      }
      var fits = handles.indexOf(handleOf(v)) !== -1;
      status.className = 'ymm-fit__status ' + (fits ? 'is-fit' : 'is-nofit');
      status.innerHTML = fits
        ? '<span class="ymm-fit__icon">&#10003;</span><span><strong>Fits your ' + nameOf(v) + '</strong></span>'
        : '<span class="ymm-fit__icon">&#10005;</span><span><strong>Does not fit your ' + nameOf(v) + '</strong>' +
          '<a href="' + urlOf(v) + '">Shop parts that fit &rarr;</a></span>';
      status.insertAdjacentHTML('beforeend', '<button type="button" class="ymm-fit__change" data-ymm-clear>Change</button>');
      status.hidden = false; checker.hidden = true;
    }
    root.addEventListener('click', function (e) { if (e.target.closest('[data-ymm-clear]')) setVehicle(null); });
    document.addEventListener('ymm:change', render);
    render();
  }

  /* ---------- Vehicle collection page: remember the vehicle being browsed ---------- */
  function initCollection(el) {
    var v = { year: +el.getAttribute('data-year'), make: el.getAttribute('data-make'), model: el.getAttribute('data-model') };
    var cur = getVehicle();
    if (!cur || handleOf(cur) !== handleOf(v)) setVehicle(v);
  }

  /* ---------- Keyword search within the selected vehicle ---------- */
  // Each typed word must match; a word also matches any of its synonyms.
  var SYNONYMS = {
    ecu: ['ecu', 'ecm', 'control unit', 'control module', 'module'],
    ecm: ['ecu', 'ecm', 'control unit', 'control module'],
    module: ['module', 'ecu', 'control unit'],
    ac: ['ac', 'a/c', 'a c', 'air conditioning', 'hvac'],
    'a/c': ['ac', 'a/c', 'a c', 'air conditioning'],
    hvac: ['hvac', 'a/c', 'heater', 'blower', 'blend door', 'climate'],
    abs: ['abs', 'anti-lock', 'anti lock', 'antilock'],
    maf: ['maf', 'mass air flow'],
    hub: ['hub', 'knuckle', 'bearing'],
    knuckle: ['knuckle', 'hub'],
    'tail light': ['tail light', 'taillight', 'tail lamp'],
    headlight: ['headlight', 'head light', 'headlamp', 'head lamp'],
    radio: ['radio', 'audio', 'stereo', 'head unit', 'cd player', 'navigation'],
    nav: ['nav', 'navigation'],
    trans: ['transmission', 'gearbox'],
    transmission: ['transmission', 'gearbox'],
    'head light': ['headlight', 'head light', 'headlamp', 'head lamp'],
    diff: ['diff', 'differential'],
    differential: ['differential', 'diff'],
    shock: ['shock', 'strut', 'damper'],
    strut: ['strut', 'shock', 'damper'],
    window: ['window', 'glass', 'regulator'],
    mirror: ['mirror'],
    seat: ['seat'],
  };
  function norm(s) { return String(s || '').toLowerCase().replace(/[–—]/g, '-').replace(/\s+/g, ' '); }

  /* ----- Spelling forgiveness: correct typed words against part words from the store's own titles ----- */
  var VOCAB = null, VOCAB_LIST = [], PHRASES = [];
  function loadTerms() {
    if (loadTerms.p) return loadTerms.p;
    var url = dataEl.getAttribute('data-terms-url');
    return (loadTerms.p = (url ? fetch(url).then(function (r) { return r.json(); }) : Promise.resolve({ words: [], phrases: [] }))
      .then(function (j) {
        VOCAB = {};
        j.words.forEach(function (w) { VOCAB[w[0]] = w[1]; });
        Object.keys(SYNONYMS).forEach(function (k) { SYNONYMS[k].concat(k).forEach(function (a) { if (a.indexOf(' ') < 0 && !VOCAB[a]) VOCAB[a] = 1; }); });
        VOCAB_LIST = Object.keys(VOCAB);
        PHRASES = j.phrases;
      }).catch(function () { VOCAB = {}; }));
  }
  // Damerau-Levenshtein (optimal string alignment) distance with early exit.
  function editDistance(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev2 = null, prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      var rowMin = i;
      for (j = 1; j <= b.length; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (prev2 && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v;
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[b.length];
  }
  function skeleton(w) { return w[0] + w.slice(1).replace(/[aeiouy]/g, '').replace(/(.)\1+/g, '$1'); } // "differenshul" -> "dfrnshl"
  function correctWord(w) {
    if (!VOCAB || w.length < 4 || /\d/.test(w) || VOCAB[w] || SYNONYMS[w]) return w;
    // a partial word that starts a real part word is fine ("diff" -> matches "differential")
    for (var i = 0; i < VOCAB_LIST.length; i++) if (VOCAB_LIST[i].indexOf(w) === 0) return w;
    var max = w.length <= 4 ? 1 : w.length <= 7 ? 2 : 3, best = null, bestScore = Infinity, sk = skeleton(w);
    VOCAB_LIST.forEach(function (v) {
      if (v.length < 3) return;
      var d = editDistance(w, v, max);
      var ds = editDistance(sk, skeleton(v), Math.max(1, max - 1));
      var score = Math.min(d, ds <= Math.max(1, max - 1) ? ds + 0.5 : 99);
      if (score <= max && (score < bestScore || (score === bestScore && VOCAB[v] > VOCAB[best]))) { best = v; bestScore = score; }
    });
    return best || w;
  }
  function correctQuery(query) {
    var words = norm(query).trim().split(' ').filter(Boolean);
    var fixed = words.map(function (w) { return w.length > 4 && w.slice(-1) === 's' && VOCAB && VOCAB[w.slice(0, -1)] ? w : correctWord(w); });
    return { text: fixed.join(' '), changed: fixed.join(' ') !== words.join(' ') };
  }

  function terms(query) {
    var q = norm(query).trim(), out = [];
    // two-word synonym keys first ("tail light", "control arm" stays as two words both required)
    Object.keys(SYNONYMS).forEach(function (k) { if (k.indexOf(' ') > -1 && q.indexOf(k) > -1) { out.push(SYNONYMS[k]); q = q.replace(k, ' '); } });
    q.split(' ').filter(Boolean).forEach(function (w) {
      if (w.length > 3 && w.slice(-1) === 's' && !SYNONYMS[w]) w = w.slice(0, -1); // hubs -> hub
      out.push(SYNONYMS[w] || [w]);
    });
    return out;
  }
  function reEscape(s) { return s.replace(/[.*+?^${}()|[\]\\\/]/g, '\\$&'); }
  // Words match at the start of a word ("hub" matches "hubs", "ac" does not match "bracket").
  function compile(groups) {
    return groups.map(function (alts) { return new RegExp('(^|[^a-z0-9])(' + alts.map(reEscape).join('|') + ')', 'i'); });
  }
  function matches(p, groups, withTags) {
    var hay = norm([p.title, (p.variants || []).map(function (v) { return v.sku; }).join(' ')]
      .concat(withTags ? [p.product_type, (p.tags || []).join(' ')] : []).join(' | '));
    return compile(groups).every(function (re) { return re.test(hay); });
  }
  // Title/SKU matches first; fall back to tags/type only if the title finds nothing.
  function rawSearch(products, query) {
    var groups = terms(query);
    var hits = products.filter(function (p) { return matches(p, groups, false); });
    return hits.length ? hits : products.filter(function (p) { return matches(p, groups, true); });
  }
  // Returns { hits, used, corrected }: tries what was typed, then the spell-corrected version.
  function search(products, query) {
    var hits = rawSearch(products, query);
    if (hits.length) return { hits: hits, used: query, corrected: false };
    var c = correctQuery(query);
    if (c.changed) { hits = rawSearch(products, c.text); if (hits.length) return { hits: hits, used: c.text, corrected: true }; }
    return { hits: [], used: query, corrected: false };
  }
  function money(cents) { return '$' + Number(cents).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var productCache = {};
  function loadCollectionProducts(handle) {
    if (productCache[handle]) return productCache[handle];
    var all = [];
    function page(n) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) { all = all.concat(j.products); return j.products.length === 250 && n < 20 ? page(n + 1) : all; });
    }
    return (productCache[handle] = page(1));
  }

  function initResults(box) {
    var handle = box.getAttribute('data-collection');
    var name = box.getAttribute('data-name');
    var form = document.querySelector('[data-ymm-coll-search]');
    var input = document.querySelector('[data-ymm-coll-q]');

    function run(query) {
      query = (query || '').trim();
      var url = new URL(window.location.href);
      if (query) url.searchParams.set('q', query); else url.searchParams.delete('q');
      history.replaceState(null, '', url);
      if (!query) { box.hidden = true; document.body.classList.remove('ymm-searching'); return; }
      document.body.classList.add('ymm-searching');
      box.hidden = false;
      box.innerHTML = '<p class="ymm-results__msg">Searching ' + esc(name) + ' parts…</p>';
      Promise.all([loadCollectionProducts(handle), loadTerms()]).then(function (res) {
        var products = res[0];
        var found = search(products, query), hits = found.hits;
        var head = '<div class="ymm-results__head"><span><strong>' + hits.length + '</strong> result' + (hits.length === 1 ? '' : 's') +
          ' for &ldquo;' + esc(found.used) + '&rdquo; that fit your <strong>' + esc(name) + '</strong>' +
          (found.corrected ? '<span class="ymm-results__dym">You typed &ldquo;' + esc(query) + '&rdquo;</span>' : '') + '</span>' +
          '<button type="button" class="ymm-link-btn ymm-results__clear" data-ymm-results-clear>Show all ' + products.length + ' parts</button></div>';
        if (!hits.length) {
          box.innerHTML = head + '<div class="ymm-results__empty"><p>No matches for that search on this vehicle.</p>' +
            '<p>Try a different word, or <a href="' + esc(box.getAttribute('data-request')) + '">send us a part request</a> and we\'ll find it.</p></div>';
          return;
        }
        box.innerHTML = head + '<div class="ymm-results__grid">' + hits.map(function (p) {
          var v = p.variants[0] || {};
          var img = p.images[0] ? p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
          var price = Math.round(parseFloat(v.price || 0) * 100);
          var compare = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
          var soldOut = p.variants.every(function (x) { return !x.available; });
          return '<a class="ymm-card" href="/products/' + p.handle + '">' +
            '<span class="ymm-card__img">' + (img ? '<img loading="lazy" src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '') +
            (soldOut ? '<span class="ymm-card__badge">Sold out</span>' : '') + '</span>' +
            '<span class="ymm-card__title">' + esc(p.title) + '</span>' +
            '<span class="ymm-card__price">' + money(price / 100) + (compare > price ? ' <s>' + money(compare / 100) + '</s>' : '') + '</span>' +
            '<span class="ymm-card__fit">&#10003; Fits your ' + esc(name) + '</span></a>';
        }).join('') + '</div>';
      }).catch(function () {
        box.innerHTML = '<p class="ymm-results__msg">Search is unavailable right now. Scroll down to browse all parts for your vehicle.</p>';
        document.body.classList.remove('ymm-searching');
      });
    }

    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); run(input.value); });
    box.addEventListener('click', function (e) { if (e.target.closest('[data-ymm-results-clear]')) { input.value = ''; run(''); } });
    var initial = new URLSearchParams(window.location.search).get('q');
    if (initial) { input.value = initial; run(initial); }
  }

  /* ---------- Type-ahead suggestions ---------- */
  // getHandle(): vehicle collection handle to show live parts for, or null to suggest part words only.
  // onPick(text): called when a word suggestion is chosen; product suggestions are links.
  function attachSuggest(input, getHandle, onSubmit) {
    var wrap = document.createElement('div');
    wrap.className = 'ymm-suggest';
    wrap.hidden = true;
    input.parentNode.style.position = 'relative';
    input.parentNode.appendChild(wrap);
    input.setAttribute('autocomplete', 'off');
    var timer, items = [], active = -1, lastQ = '';

    function hide() { wrap.hidden = true; active = -1; }
    function setActive(i) {
      items.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      active = i;
    }
    function wordSuggestions(q) {
      var c = correctQuery(q).text, lastWord = c.split(' ').pop(), head = c.slice(0, c.length - lastWord.length);
      var out = [], seen = {};
      function add(t) { if (!seen[t] && out.length < 8) { seen[t] = 1; out.push(t); } }
      PHRASES.forEach(function (p) { if (p[0].indexOf(c) === 0) add(p[0]); });
      VOCAB_LIST.slice().sort(function (a, b) { return VOCAB[b] - VOCAB[a]; }).forEach(function (w) { if (lastWord && w.indexOf(lastWord) === 0) add((head + w).trim()); });
      PHRASES.forEach(function (p) { if (lastWord && p[0].indexOf(' ' + lastWord) > -1) add(p[0]); });
      return out;
    }
    function render(q) {
      var handle = getHandle && getHandle();
      Promise.all([loadTerms(), handle ? loadCollectionProducts(handle) : Promise.resolve(null)]).then(function (res) {
        if (input.value.trim() !== q) return; // user kept typing
        var products = res[1], html = '';
        if (products) {
          var found = search(products, q), hits = found.hits.slice(0, 6);
          if (found.corrected) html += '<div class="ymm-suggest__note">Showing results for <strong>' + esc(found.used) + '</strong></div>';
          html += hits.map(function (p) {
            var img = p.images[0] ? p.images[0].src.replace(/(\.[a-z]+)(\?|$)/i, '_100x$1$2') : '';
            return '<a class="ymm-suggest__item ymm-suggest__item--product" href="/products/' + p.handle + '">' +
              (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="ymm-suggest__noimg"></span>') +
              '<span class="ymm-suggest__title">' + esc(p.title) + '</span>' +
              '<span class="ymm-suggest__price">' + money(parseFloat(p.variants[0] ? p.variants[0].price : 0)) + '</span></a>';
          }).join('');
          if (found.hits.length) html += '<button type="button" class="ymm-suggest__item ymm-suggest__all" data-q="' + esc(found.used) + '">See all ' + found.hits.length + ' results for &ldquo;' + esc(found.used) + '&rdquo; &rarr;</button>';
          else html += '<div class="ymm-suggest__note">No parts match &ldquo;' + esc(q) + '&rdquo; for this vehicle.</div>';
        } else {
          html = wordSuggestions(q).map(function (t) { return '<button type="button" class="ymm-suggest__item" data-q="' + esc(t) + '">' + esc(t) + '</button>'; }).join('');
        }
        wrap.innerHTML = html;
        items = Array.prototype.slice.call(wrap.querySelectorAll('.ymm-suggest__item'));
        active = -1;
        wrap.hidden = !html;
      });
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () { lastQ = q; render(q); }, 150);
    });
    input.addEventListener('focus', function () { loadTerms(); if (input.value.trim().length >= 2) render(input.value.trim()); });
    input.addEventListener('keydown', function (e) {
      if (wrap.hidden || !items.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive((active + 1) % items.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive((active - 1 + items.length) % items.length); }
      else if (e.key === 'Escape') { hide(); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); items[active].click(); }
    });
    wrap.addEventListener('mousedown', function (e) { e.preventDefault(); }); // keep focus while clicking
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]');
      if (!b) return;
      input.value = b.getAttribute('data-q');
      hide();
      if (onSubmit) onSubmit(input.value);
    });
    input.addEventListener('blur', function () { setTimeout(hide, 150); });
    input.form && input.form.addEventListener('submit', hide);
  }

  // Vehicle page search box: live parts for this vehicle
  document.querySelectorAll('[data-ymm-coll-q]').forEach(function (input) {
    var box = document.querySelector('[data-ymm-results]');
    attachSuggest(input, function () { return box && box.getAttribute('data-collection'); }, function () { input.form.requestSubmit(); });
  });
  // Header "search parts for your vehicle" box: live parts for the saved vehicle
  document.querySelectorAll('[data-ymm-garage-q]').forEach(function (input) {
    attachSuggest(input, function () { var v = getVehicle(); return v ? handleOf(v) : null; }, function () { input.form.requestSubmit(); });
  });
  // Finder 4th box: live parts once Year/Make/Model are chosen, otherwise part-word suggestions
  document.querySelectorAll('[data-ymm-finder][data-mode="navigate"]').forEach(function (root) {
    var input = root.querySelector('[data-ymm-q]');
    if (!input) return;
    attachSuggest(input, function () {
      var y = root.querySelector('[data-ymm-year]').value, mk = root.querySelector('[data-ymm-make]').value, md = root.querySelector('[data-ymm-model]').value;
      return y && mk && md ? handleOf({ year: y, make: mk, model: md }) : null;
    }, null);
  });

  document.querySelectorAll('[data-ymm-garage-search]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = getVehicle(); if (!v) return;
      var term = form.querySelector('[data-ymm-garage-q]').value.trim();
      var onVehiclePage = document.querySelector('[data-ymm-results][data-collection="' + handleOf(v) + '"]');
      if (onVehiclePage) { var i = document.querySelector('[data-ymm-coll-q]'); i.value = term; i.form.requestSubmit(); i.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      window.location.href = urlOf(v) + (term ? '?q=' + encodeURIComponent(term) : '');
    });
  });
  document.querySelectorAll('[data-ymm-results]').forEach(initResults);
  document.querySelectorAll('[data-ymm-finder]').forEach(initFinder);
  document.querySelectorAll('[data-ymm-fit]').forEach(initFit);
  document.querySelectorAll('[data-ymm-collection]').forEach(initCollection);
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ymm-garage-clear]')) { setVehicle(null); }
    if (e.target.closest('[data-ymm-open]')) {
      // "Change vehicle" = start fresh: clear the saved vehicle and reset the finder.
      setVehicle(null);
      var bar = document.querySelector('[data-ymm-bar]');
      if (bar) { bar.scrollIntoView({ behavior: 'smooth', block: 'start' }); var y = bar.querySelector('[data-ymm-year]'); if (y) setTimeout(function () { y.focus(); }, 300); }
    }
  });
  document.addEventListener('ymm:change', renderGarage);
  renderGarage();

  /* ---------- Put the selected vehicle on the order (line item property + cart attribute) ---------- */
  var PROP = 'properties[Vehicle]';
  function stampForm(form) {
    var v = getVehicle();
    var input = form.querySelector('input[name="' + PROP + '"]');
    if (!v) { if (input) input.remove(); return; }
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = PROP; form.appendChild(input); }
    input.value = nameOf(v);
  }
  function stampAll() { document.querySelectorAll('form[action*="/cart/add"]').forEach(stampForm); }
  // Saves the vehicle as a cart attribute AND as a "Vehicle: ..." line at the top of the order note
  // (the packing slip always prints the order note). Any note the customer typed is kept.
  function syncCartAttribute() {
    var v = getVehicle(), value = v ? nameOf(v) : '';
    try { if (sessionStorage.getItem('rl_ymm_cart_attr') === value) return; } catch (e) {}
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var rest = String(cart.note || '').split('\n').filter(function (l) { return !/^Vehicle:/i.test(l.trim()); }).join('\n').trim();
      var note = value ? ('Vehicle: ' + value + (rest ? '\n' + rest : '')) : rest;
      return fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Vehicle': value }, note: note })
      });
    }).then(function (r) { if (r && r.ok) { try { sessionStorage.setItem('rl_ymm_cart_attr', value); } catch (e) {} } }).catch(function () {});
  }
  // Stamp right before any add-to-cart (covers ajax carts and quick-shop forms rendered later).
  ['submit', 'click'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
      if (form) stampForm(form);
    }, true);
  });
  new MutationObserver(function () { stampAll(); }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('ymm:change', function () { stampAll(); syncCartAttribute(); });
  stampAll();
  syncCartAttribute();
})();
